import Error404 from './error404';
export default Error404;